import { EXAMPLE_QUERIES } from './searchShortcuts'

type SearchExampleChipsProps = {
  onSelect: (_query: string) => void
}

/** Tappable example queries ("2:255", "Kuran 50", ...) that fill the search field. */
const SearchExampleChips = ({ onSelect }: SearchExampleChipsProps) => (
  <div className="flex flex-wrap gap-2">
    {EXAMPLE_QUERIES.map((query) => (
      <button
        key={query}
        type="button"
        onClick={() => onSelect(query)}
        className="rounded-full border border-main bg-main px-3 py-1.5 text-sm text-main transition-colors hover:border-primary/50 active:bg-surface-strong"
      >
        {query}
      </button>
    ))}
  </div>
)

export default SearchExampleChips
